const config = {
  'production': {
    RPC_NODES : [
      'https://rpc.blurt.blog',
    ],
    EFTG_HARDFORK_0_1 : false
  },
  'acceptance': {
    RPC_NODES : [
      'https://api.blkcc.xyz'
    ],
    EFTG_HARDFORK_0_1 : false
  },
  'development': {
    RPC_NODES : [
      'https://rpc.blurt.blog',
    ],
    EFTG_HARDFORK_0_1 : true
  },
  'testnet': {
    RPC_NODES : [
      'https://testnet.blurt.blog',
    ],
    EFTG_HARDFORK_0_1 : false
  },
}

const environment = process.env.NODE_ENV || 'development';
const finalConfig = config[environment];

const PAGE_AFTER_LOGIN = '/'
const PAGE_AFTER_LOGOUT = '/'

const BLURT = environment === "testnet" ? 'TESTS' : 'BLURT';
const BP = environment === "testnet" ? 'TP' : 'BP';
const VESTS = 'VESTS';

const HARDFORK = 8

const EXPLORER = '/'
const EXPLORER2 = '/blurtexplorer/#/explorer/'
const BLOG_URL = 'https://blurt.blog/'
const BEBLURT_URL='https://beblurt.com/'

const DBLURT_TIMEOUT = 5000 //ms

const BLURT_ADDRESS_PREFIX = environment === "testnet" ? 'TST' : 'BLT';
const BLURT_100_PERCENT = 10000;
const BLURT_VOTE_REGENERATION_SECONDS = 5 * 24 * 60 * 60;
const BLURT_INFLATION_RATE_START_PERCENT = 1000;
const BLURT_INFLATION_NARROWING_PERIOD = 250000;
const BLURT_INFLATION_RATE_STOP_PERCENT = 95;
const BLURT_BLOCKS_PER_YEAR = (365 * 24 * 60 * 60) / 3;
const BLURT_BLOCKS_PER_DAY = (24 * 60 * 60) / 3;

const BLURT_CHAIN_ID = environment === "testnet" ? '1df54a5cc86f7c7efee2402e1304df6eae24eb8766a63c0546c1b2511cf5eba6' : 'cd8d90f29ae273abec3eaa7731e25934c63eb654d55080caff2ebb7f5df6381f';
const BLURT_PROPOSAL_MAX_IDS_NUMBER = 5

const MAP = {
  TOP_WITNESSES: 30,
  INI_POS : [40, 0], //latitude, longitude
  INI_ZOOM : 1 ,
}

const APP_VERSION = 'blurtexplorer/2.1.0';

export default {

  RPC_NODES: finalConfig.RPC_NODES,
  IMAGE_HOSTER: finalConfig.IMAGE_HOSTER,
  ELASTIC: finalConfig.ELASTIC,
  CDN: finalConfig.CDN,
  SERVER_API: finalConfig.SERVER_API,

  PAGE_AFTER_LOGIN,
  PAGE_AFTER_LOGOUT,

  BLURT: BLURT,
  BP: BP,
  VESTS: VESTS,
  HARDFORK: HARDFORK,

  EFTG_HARDFORK_0_1: finalConfig.EFTG_HARDFORK_0_1,

  EXPLORER,
  EXPLORER2,
  DBLURT_TIMEOUT,
  BLOG_URL,
  BEBLURT_URL,
  BLURT_ADDRESS_PREFIX: BLURT_ADDRESS_PREFIX,
  BLURT_100_PERCENT: BLURT_100_PERCENT,
  BLURT_VOTE_REGENERATION_SECONDS: BLURT_VOTE_REGENERATION_SECONDS,
  BLURT_INFLATION_RATE_START_PERCENT: BLURT_INFLATION_RATE_START_PERCENT,
  BLURT_INFLATION_NARROWING_PERIOD: BLURT_INFLATION_NARROWING_PERIOD,
  BLURT_INFLATION_RATE_STOP_PERCENT: BLURT_INFLATION_RATE_STOP_PERCENT,
  BLURT_BLOCKS_PER_YEAR: BLURT_BLOCKS_PER_YEAR,
  BLURT_BLOCKS_PER_DAY: BLURT_BLOCKS_PER_DAY,
  BLURT_CHAIN_ID,
  BLURT_PROPOSAL_MAX_IDS_NUMBER,

  MAP:MAP,

  APP_VERSION: APP_VERSION,
};
